import {
  GetSponsorsResponseProto,
  SponsorProto,
} from "@noom/noom-contracts/noom_contracts/backend/partner/service/partner_service";
import { Api } from "@noom/noomscape";

import { captureException } from "@/utils/sentry";

import axios, { AxiosError } from "axios";

const REQUEST_TIMEOUT_MS = 5000;

export type Sponsor = SponsorProto;

type RequestParams = {
  query: string;
  limit?: number;
  signal?: AbortSignal;
};

export const SPONSOR_SEARCH_MIN_QUERY_LENGTH = 4;
export const SPONSOR_SEARCH_DEFAULT_LIMIT = 8;

Api.register(
  "partner.getSponsors",
  async ({
    query,
    limit = SPONSOR_SEARCH_DEFAULT_LIMIT,
    signal,
  }: RequestParams): Promise<Sponsor[]> => {
    try {
      const response = await axios<GetSponsorsResponseProto>({
        baseURL: window.ENV.B2B_PARTNER_URL,
        method: "GET",
        params: {
          query,
          limit,
        },
        signal,
        timeout: REQUEST_TIMEOUT_MS,
        url: "/partners/v2/sponsors",
        urlWithPathParams: "/partners/v2/sponsors",
      });

      return response.data.sponsors ?? [];
    } catch (e) {
      if (signal?.aborted || axios.isCancel?.(e)) {
        throw e;
      }
      const status = (e as AxiosError).response?.status;
      if (status === 429) {
        throw e;
      }
      captureException(e);
      throw e;
    }
  },
);
